import { ActionIcon, Group, Indicator, Tooltip } from "@mantine/core"
import { SquaresFourIcon, ListIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next"

type Props = {
  mode: "list" | "kanban"
  onChange: (mode: "list" | "kanban") => void
  kanbanBadge?: number
}

export function ViewSwitcher({ mode, onChange, kanbanBadge = 0 }: Props) {
  const { t } = useTranslation("order")
  return (
    <Group gap={4}>
      <ActionIcon
        variant={mode === "list" ? "filled" : "light"}
        color={mode === "list" ? "dark" : "gray"}
        size="lg"
        radius="md"
        onClick={() => onChange("list")}
      >
        <ListIcon size={18} />
      </ActionIcon>
      <Indicator
        label={kanbanBadge > 99 ? "99+" : kanbanBadge}
        size={18}
        color="red"
        offset={4}
        disabled={kanbanBadge <= 0}
        styles={{ indicator: { fontWeight: 700, fontSize: 10, paddingInline: 4 } }}
      >
        <Tooltip label={t("viewSwitcher.kanbanTooltip")} withArrow position="top" openDelay={400} disabled={kanbanBadge <= 0}>
          <ActionIcon
            variant={mode === "kanban" ? "filled" : "light"}
            color={mode === "kanban" ? "dark" : "gray"}
            size="lg"
            radius="md"
            onClick={() => onChange("kanban")}
          >
            <SquaresFourIcon size={18} />
          </ActionIcon>
        </Tooltip>
      </Indicator>
    </Group>
  )
}
